import { render, staticRenderFns } from "./AppSettingCPModal.vue?vue&type=template&id=96473c92&"
import script from "./AppSettingCPModal.vue?vue&type=script&lang=js&"
export * from "./AppSettingCPModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports